import { render, staticRenderFns } from "./ThankyouPage.vue?vue&type=template&id=d8d13260&scoped=true&"
import script from "./ThankyouPage.vue?vue&type=script&lang=js&"
export * from "./ThankyouPage.vue?vue&type=script&lang=js&"
import style0 from "./ThankyouPage.vue?vue&type=style&index=0&id=d8d13260&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8d13260",
  null
  
)

export default component.exports